module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-20-ab3d57364e6eb0e00ff6d685c7bb74a9.png";